import React from 'react';

export const PA_API = `${process.env.REACT_APP_BACKEND_URL}/api/portal-admin`;
export const ACCOUNT_ROLES = ['super_admin', 'admin', 'office_admin'];
export const paErr = (e, fb = 'Something went wrong') => { const d = e?.response?.data?.detail; return typeof d === 'string' ? d : Array.isArray(d) ? d.map((x) => x.msg).join(' ') : fb; };
export const authedUrl = (path) => `${PA_API}${path}?token=${encodeURIComponent(localStorage.getItem('token') || '')}`;
export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Toronto' }) : '—');
export const fmtD = (d) => (d ? new Date(`${String(d).slice(0, 10)}T12:00:00`).toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' }) : '—');

export const Panel = ({ children, className = '', testId }) => (
  <div className={`bg-white border border-slate-200 rounded-2xl ${className}`} data-testid={testId}>{children}</div>
);

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="text-[11px] uppercase tracking-wider font-bold text-slate-500">{label}</span>
    <div className="mt-1">{children}</div>
    {hint && <span className="text-xs text-slate-500 mt-1 block">{hint}</span>}
  </label>
);

export const inputCls = 'w-full px-3 py-2 rounded-lg bg-white border border-slate-300 text-slate-900 text-sm outline-none focus:ring-2 focus:ring-blue-500';
export const btnPrimary = 'px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 disabled:bg-slate-300 text-white text-sm font-semibold inline-flex items-center gap-1.5';
export const btnGhost = 'px-3 py-2 rounded-lg bg-slate-900/5 hover:bg-slate-900/10 text-slate-900 text-sm font-semibold inline-flex items-center gap-1.5';
export const btnDanger = 'px-3 py-2 rounded-lg bg-rose-600 hover:bg-rose-700 text-white text-sm font-semibold inline-flex items-center gap-1.5';

export const Pill = ({ tone = 'slate', children, testId }) => {
  const t = { slate: 'bg-slate-100 text-slate-800', green: 'bg-emerald-50 text-emerald-700 border border-emerald-200', amber: 'bg-amber-50 text-amber-700 border border-amber-200',
    red: 'bg-rose-50 text-rose-700 border border-rose-200', blue: 'bg-blue-50 text-blue-800 border border-blue-200', purple: 'bg-purple-50 text-purple-800 border border-purple-200' }[tone];
  return <span className={`inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${t}`} data-testid={testId}>{children}</span>;
};

export const Overlay = ({ title, onClose, children, wide }) => (
  <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
    <div className="absolute inset-0 bg-black/60" onClick={onClose} />
    <div className={`relative w-full ${wide ? 'max-w-3xl' : 'max-w-xl'} max-h-[92vh] overflow-y-auto bg-white border border-slate-300 rounded-2xl shadow-2xl p-5`}>
      <div className="flex items-start justify-between gap-3 mb-4">
        <h3 className="text-lg font-bold text-slate-900">{title}</h3>
        <button type="button" onClick={onClose} className="text-slate-500 hover:text-slate-900 text-2xl leading-none" aria-label="Close" data-testid="pa-overlay-close">×</button>
      </div>
      {children}
    </div>
  </div>
);
